module.exports = __webpack_public_path__ + "img/60_2.eec27514.png";